import {
  getDefaultSignupDateRangeIso,
  formatSignupDateRangeDisplay,
} from "@/utils/defaultSignupDateRange";

export const namespaced = true

const defaultSignupRange = getDefaultSignupDateRangeIso();

export const state = {
    loan_status: "step_applied",
    profile_status: null,
    loan_steps: null,
    date_range: defaultSignupRange,
    display_daterange: formatSignupDateRangeDisplay(defaultSignupRange),
    current_city: "",
    page_number: 1,
    fd_display_date: null,
    follow_up_date: null,
    label: null,
    source: null,
    // for status date filter
    status_date_range: [],
    display_status_daterange: "",
    assigned_agent: "",
    // The agent combobox binds `agent_assigned`; declared here so Vue tracks
    // it (a property added to Vuex state at runtime is not reactive).
    agent_assigned: null,
    agent_type: "",
}

export const mutations = {
    SET_DEFAULT_SIGNUP_DATE_RANGE(state, { date_range, display_daterange }) {
        state.date_range = date_range;
        state.display_daterange = display_daterange;
    },
    SET_FILTER(state, {loan_status, profile_status, loan_steps, fd_display_date, date_range, display_daterange, display_status_daterange, status_date_range, page_number, assigned_agent, agent_type}) {
        state.loan_status = loan_status;
        state.profile_status = profile_status;
        state.page_number = page_number;
        state.loan_steps = loan_steps;
        state.date_range = date_range;
        state.display_daterange = display_daterange;
        state.fd_display_date = fd_display_date;
        
        // for status date filter
        state.status_date_range = status_date_range;
        state.display_status_daterange = display_status_daterange;

        state.assigned_agent = assigned_agent;
        state.agent_type = agent_type;
    },

}

export const actions = {
    setFilters({commit}, items) {
        commit('SET_FILTER', items)
    },
}
export const getters = {
    getFilters: state => {
        return state;
    },
}